<template lang="pug">
v-app
  DialogArteDivulgacao(ref="dialogArte")

  v-container(grid-list-xl, fluid).home-container

    //- Sem estabelecimento selecionado
    .home-empty-store(v-if="!estabelecimentoSelecionado || !estabelecimentoSelecionado.id")
      v-icon.home-empty-store__icon store
      .home-empty-store__title Selecione uma loja
      .home-empty-store__sub Escolha um estabelecimento no topo da página para visualizar o painel
      v-btn.home-empty-store__cta.white--text(depressed, color="#1d9a5a", @click="abrirSelecaoLoja")
        v-icon(left, small) storefront
        | Selecionar loja

    template(v-else)
      //- ===== HERO =====
      .home-hero
        .home-hero__decor.home-hero__decor--1
        .home-hero__decor.home-hero__decor--2
        .home-hero__content
          .home-hero__left
            .home-hero__greeting {{ saudacao }}, {{ primeiroNome }}
            .home-hero__date {{ dataLonga }}
            .home-hero__chips
              span.home-chip(:class="lojaAberta ? 'home-chip--open' : 'home-chip--closed'")
                span.home-chip__dot
                | {{ lojaAberta ? 'LOJA ABERTA' : 'LOJA FECHADA' }}
              span.home-chip.home-chip--neutral(v-if="resumo && resumo.cupons_ativos > 0")
                v-icon(size="13", color="#c8e6d4") local_offer
                | {{ resumo.cupons_ativos }} {{ resumo.cupons_ativos == 1 ? 'cupom ativo' : 'cupons ativos' }}
          .home-hero__right
            //- ===== FATURAMENTO 7 DIAS — REMOVIDO TEMPORARIAMENTE =====
            //- Para reativar: remover 2 espaços de indentação do bloco abaixo e apagar este comentário.
              .home-hero__stat
                .home-hero__stat-label Faturamento · últimos 7 dias
                .home-hero__stat-value(v-if="!loading") {{ faturamento7 | currency }}
                .home-hero__stat-skeleton(v-else)
                .home-hero__stat-sub(v-if="!loading") {{ pedidos7 | number }} {{ pedidos7 == 1 ? 'pedido' : 'pedidos' }} · ticket médio {{ ticketMedio7 | currency }}
            BotaoVerLoja(:estabelecimento="estabelecimentoSelecionado", origem="home")
            v-btn.home-hero__refresh(icon, @click="fetchData", :loading="loading")
              v-icon(color="white") refresh

      //- ===== BANNERS (plataforma Bigou Pedidos) =====
      HomeBanners(:localidadeId="estabelecimentoSelecionado.localidade_id", :estabelecimentoId="estabelecimentoSelecionado.id")

      //- ===== RESUMO 28 DIAS =====
        v-layout(row, wrap).mt-1.mb-4
          v-flex(xs12)
            .home-card.pa-4
              .home-section-head
                div
                  .home-section-title Visão dos últimos 28 dias
                  .home-section-sub(v-if="metadadosAtualizadosEm") atualizado em {{ metadadosAtualizadosEm }}
                v-btn(flat, small, color="primary", @click="$router.push('/delivery/relatorio')").ma-0.home-link-btn Ver relatório completo
              v-layout(row, wrap, v-if="!loading")
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Faturamento
                    .home-mini__value {{ faturamento28 | currency }}
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Pedidos
                    .home-mini__value {{ pedidos28 | number }}
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Ticket médio
                    .home-mini__value {{ ticketMedio28 | currency }}
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Clientes únicos
                    .home-mini__value {{ clientesUnicos28 | number }}
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Novos clientes
                    .home-mini__value {{ clientesNovos28 | number }}
                v-flex(xs6, sm4, md2)
                  .home-mini
                    .home-mini__label Cancelamento
                    .home-mini__value(:class="{ 'home-mini__value--red': taxaCancelamento28 > 5 }") {{ formatNota(taxaCancelamento28) }}%
              .home-chart-skeleton(v-else, style="height:70px")

      //- ===== NOVIDADES PARA ATIVAR + CTA CUPOM (regra do sistema) =====
      //- Só aparece quando há novidade disponível (isNovidadePromo). Sem novidade,
      //- o banner de cupom desce para a linha de baixo (pedidos + notificações).
      .home-promo-row.mt-4(v-if="promocoesNovidade.length && $root.podeAcessarPerfil(['administrador'])")
        .home-promo-col
          .home-card.pa-4
            .home-section-head
              div
                .home-section-title Novidades para ativar
                .home-section-sub(v-if="promocoesNovidade.length") {{ promocoesNovidade.length }} {{ promocoesNovidade.length == 1 ? 'novidade disponível' : 'novidades disponíveis' }}
                .home-section-sub(v-else) nenhuma novidade disponível no momento
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/marketing/campanhas')").ma-0.home-link-btn Ativar agora
            template(v-if="promocoesNovidade.length")
              .home-promo(v-for="promo in promocoesNovidade", :key="promo.id")
                .home-promo__icon
                  v-icon(size="20", color="#c07d0a") local_offer
                .home-promo__info
                  .home-promo__linha-nome
                    span.home-promo__nome {{ promo.nome }}
                    span.home-promo__segmentado(v-if="isPromoSegmentada(promo)") PÚBLICO SEGMENTADO
                    span.home-promo__aberto(v-else) PÚBLICO ABERTO
                  .home-promo__detalhe
                    span.home-promo__preco-de(v-if="promo.preco") {{ promo.preco | currency }}
                    span.home-promo__preco-por(v-if="promo.preco_promocional") {{ promo.preco_promocional | currency }}
                    span.home-promo__vigencia(v-if="promo.data_inicio || promo.data_fim") · {{ formatDataCurta(promo.data_inicio) }} — {{ formatDataCurta(promo.data_fim) }}
                  .home-promo__subsidio(v-if="Number(promo.valorSubsidio) > 0") SUBSÍDIO BIGOU · Bigou paga {{ promo.valorSubsidio | currency }} · você concede {{ descontoLojistaPromo(promo) | currency }}
                span.home-promo__badge
                  v-icon(size="13", color="#1D7D4A") auto_awesome
                  | Novidade
              .home-promo__hint O Bigou preparou promoções para impulsionar sua loja. Ative e apareça em destaque para milhares de clientes.
            .home-empty(v-else)
              v-icon.home-empty__icon local_offer
              span Nenhuma novidade disponível
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/marketing/campanhas')").ma-0.home-link-btn Ver promoções
        .home-banner-col
          AnnouncementBanners(:estabelecimentoId="estabelecimentoSelecionado.id", variant="card")

      //- ===== PEDIDOS AGUARDANDO + NOTIFICAÇÕES (+ CTA cupom quando não há promoção) =====
      v-layout(row, wrap).mt-1
        v-flex(xs12, :class="pedidosColClass")
          .home-card.pa-4(style="height:100%")
            .home-section-head
              .home-section-title-row
                .home-alert__pulse(v-if="pedidosAguardandoLista.length")
                  v-icon(color="white", size="18") notifications_active
                div
                  .home-section-title Pedidos aguardando confirmação
                  .home-section-sub(v-if="pedidosAguardandoLista.length") confirme o quanto antes para não perder a venda
                  .home-section-sub(v-else) tudo em dia por aqui
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/pedidos')").ma-0.home-link-btn Ver todos
            template(v-if="pedidosAguardandoLista.length")
              .home-pedido(v-for="pedido in pedidosAguardandoLista", :key="pedido.id", @click="abrirPedido(pedido)")
                .home-pedido__info
                  .home-pedido__cliente
                    span.home-pedido__nome Pedido \#{{ pedido.id }}
                    span.home-pedido__tempo(:class="tempoClass(pedido)") há {{ tempoEspera(pedido) }} min
                  .home-pedido__itens(v-if="resumoItens(pedido)") {{ resumoItens(pedido) }}
                  .home-pedido__meta
                    span.home-pedido__tag {{ pedido.endereco_id == -1 ? 'Retirada' : 'Entrega' }}
                    span.home-pedido__sep ·
                    span.home-pedido__total {{ pedido.total | currency }}
                v-btn.home-pedido__btn(depressed, small, @click.stop="abrirPedido(pedido)") Ver pedido
                  v-icon(right, size="14") arrow_forward
            .home-empty(v-else)
              v-icon.home-empty__icon check_circle_outline
              span Nenhum pedido aguardando confirmação 🎉

        v-flex(xs12, :class="notifColClass", v-if="!isCardapioDigital")
          .home-card.pa-4(style="height:100%")
            .home-section-head
              div
                .home-section-title Últimas notificações
                .home-section-sub avisos e novidades da plataforma
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/notificacao')").ma-0.home-link-btn Ver todas
            template(v-if="ultimasNotificacoes.length")
              .home-notif(v-for="notif in ultimasNotificacoes", :key="notif.id")
                .home-notif__icon
                  v-icon(size="16", color="#3060CA") notifications
                .home-notif__info
                  .home-notif__titulo {{ notif.titulo }}
                  .home-notif__msg(v-if="notif.mensagem") {{ truncate(notif.mensagem, 80) }}
                  .home-notif__data {{ formatDataNotificacao(notif.data_envio) }}
                  v-btn.home-notif__link.ma-0.mt-1(v-if="notif.tipo_id == 2 && notif.url", flat, small, color="primary", :href="notif.url", target="_blank")
                    | Ver mais
                    v-icon(right, size="14") open_in_new
            .home-empty(v-else)
              v-icon.home-empty__icon notifications_none
              span Nenhuma notificação por enquanto

        v-flex.home-banner-flex(xs12, :class="bannerColClass", v-if="!promocoesNovidade.length")
          AnnouncementBanners(:estabelecimentoId="estabelecimentoSelecionado.id", variant="card")

      v-layout(row, wrap).mt-1
        v-flex(xs12)
          .home-card.pa-4
            .home-section-head
              div
                .home-section-title Divulgue suas ofertas
                .home-section-sub(v-if="ofertasAtivas.length") {{ ofertasAtivas.length }} {{ ofertasAtivas.length == 1 ? 'oferta ativa' : 'ofertas ativas' }} · gere a imagem e compartilhe com seus clientes
                .home-section-sub(v-else) ative uma promoção ou crie um cupom para gerar a imagem de divulgação
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/marketing')").ma-0.home-link-btn Ver marketing
            template(v-if="ofertasAtivas.length")
              .home-ofertas-cols
                .home-ofertas-col(v-for="(coluna, indice) in ofertasColunas", :key="`oferta-col-${indice}`")
                  .home-oferta(v-for="oferta in coluna", :key="oferta.key")
                    .home-oferta__icon(:class="oferta.tipo == 'cupom' ? 'home-oferta__icon--cupom' : 'home-oferta__icon--promocao'")
                      v-icon(size="20", :color="oferta.tipo == 'cupom' ? '#1d9a5a' : '#c07d0a'") {{ oferta.tipo == 'cupom' ? 'confirmation_number' : 'local_offer' }}
                    .home-oferta__info
                      .home-oferta__linha-nome
                        span.home-oferta__nome {{ oferta.titulo }}
                        span.home-oferta__tag(:class="oferta.tipo == 'cupom' ? 'home-oferta__tag--cupom' : 'home-oferta__tag--promocao'") {{ oferta.tipo == 'cupom' ? 'CUPOM' : 'PROMOÇÃO' }}
                      .home-oferta__detalhe(v-if="oferta.tipo == 'promocao'")
                        span.home-oferta__preco-de(v-if="oferta.entidade.preco") {{ oferta.entidade.preco | currency }}
                        span.home-oferta__preco-por(v-if="oferta.entidade.preco_promocional") {{ oferta.entidade.preco_promocional | currency }}
                        span.home-oferta__meta(v-if="oferta.entidade.data_fim") · até {{ formatDataCurta(oferta.entidade.data_fim) }}
                      .home-oferta__detalhe(v-else)
                        span.home-oferta__preco-por(v-if="cupomEntregaGratis(oferta.entidade)") Entrega grátis
                        span.home-oferta__preco-por(v-else-if="oferta.entidade.tipo_desconto == 2") {{ cupomPercentual(oferta.entidade) }}% OFF
                        span.home-oferta__preco-por(v-else) {{ oferta.entidade.valor_desconto | currency }} OFF
                        span.home-oferta__meta(v-if="oferta.entidade.valor_minimo > 0") · mínimo {{ oferta.entidade.valor_minimo | currency }}
                        span.home-oferta__meta(v-if="oferta.entidade.data_fim") · até {{ formatDataCurta(oferta.entidade.data_fim) }}
                    v-btn.home-oferta__btn(depressed, small, @click="abrirArteOferta(oferta)")
                      v-icon(left, size="14") share
                      | Compartilhar
              .home-oferta__hint(v-if="ofertasOcultas") + {{ ofertasOcultas }} {{ ofertasOcultas == 1 ? 'outra oferta ativa' : 'outras ofertas ativas' }} — veja todas em Marketing.
              .home-oferta__hint(v-else) A arte sai pronta em 1080×1080 para stories, feed e WhatsApp — dá para compartilhar ou baixar.
            .home-chart-skeleton(v-else-if="loadingOfertas", style="height:120px")
            .home-empty(v-else)
              v-icon.home-empty__icon image
              span Nenhuma oferta ativa para divulgar
              v-btn(flat, small, color="primary", @click="$router.push('/delivery/cupom-desconto')").ma-0.home-link-btn Criar cupom

      //- ===== HORÁRIOS DE PICO + ATALHOS =====
      v-layout(row, wrap).mt-1
        v-flex(xs12, md6)
          .home-card.pa-4(style="height:100%")
            .home-section-title Horários de pico
            .home-section-sub pedidos por hora nos últimos 7 dias
            template(v-if="!loading && temPedidosPorHora")
              e-chart(:key="`horas-${loadKey}`", :path-option="chartHoras", height="240px", width="100%")
              .home-peak(v-if="horaPico != null")
                v-icon(size="16", color="#e59a1b") whatshot
                | Seu pico é às #[b {{ horaPico }}h] — garanta equipe e estoque nesse horário
            .home-empty(v-else-if="!loading")
              v-icon.home-empty__icon access_time
              span Sem pedidos nos últimos 7 dias
            .home-chart-skeleton(v-else, style="height:240px")

        v-flex(xs12, md6)
          .home-card.pa-4(style="height:100%")
            .home-section-title Atalhos rápidos
            .home-section-sub acesse as áreas mais usadas
            .home-shortcuts
              .home-shortcut(v-for="s in atalhos", :key="s.label", @click="$router.push(s.to)")
                .home-shortcut__icon(:style="{ background: s.bg }")
                  v-icon(:color="s.color", size="20") {{ s.icon }}
                .home-shortcut__label {{ s.label }}

</template>

<script>
import _ from 'lodash';
import EChart from '@/components/EChart';
import AnnouncementBanners from '@/components/AnnouncementBanners';
import HomeBanners from '@/components/HomeBanners';
import BotaoVerLoja from '@/components/BotaoVerLoja';
import DialogArteDivulgacao from '@/components/dialog/DialogArteDivulgacao';
import ArteDivulgacao from '@/util/arteDivulgacao';
import { isAtivoPromo, isNovidadePromo } from '@/util/promocao';
import { isCupomAtivo } from '@/util/cupom';

const OFERTAS_VISIVEIS = 6;

export default {
  components: { EChart, AnnouncementBanners, HomeBanners, BotaoVerLoja, DialogArteDivulgacao },
  data() {
    return {
      loading: false,
      loadKey: 0,
      resumo: null,
      cupons: [],
      loadingOfertas: false,
      agora: Date.now(),
      timerAgora: null,
    };
  },
  computed: {
    estabelecimentoSelecionado() {
      return this.$root.estabelecimentoSelecionado;
    },
    isCardapioDigital() {
      return !!(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital);
    },
    pedidosAguardandoLista() {
      // this.agora força recalcular o tempo de espera a cada minuto
      this.agora; // eslint-disable-line no-unused-expressions
      return _.filter(this.$root.pedidos || [], p => p.status === 0);
    },
    ultimasNotificacoes() {
      const notificacoes = _.orderBy(this.$root.notificacoes || [], ['data_envio'], ['desc']);
      return _.take(notificacoes, 5);
    },
    promocoesNovidade() {
      if (this.isCardapioDigital) {
        return [];
      }
      // Mesma regra do badge "Novidade" do Marketing (isNovidadePromo):
      // status === 1 && ativo === 1 = novidade disponibilizada, aguardando o
      // parceiro ativar. Mantém Home, badge do menu e Marketing alinhados.
      return _.filter(this.$root.promocoes || [], isNovidadePromo);
    },
    temPromocao() {
      return this.promocoesNovidade.length > 0;
    },
    promocoesAtivas() {
      if (this.isCardapioDigital) {
        return [];
      }
      return _.filter(this.$root.promocoes || [], p => isAtivoPromo(p) && !ArteDivulgacao.promocaoSegmentada(p));
    },
    cuponsAtivos() {
      return _.filter(this.cupons || [], isCupomAtivo);
    },
    ofertasAtivas() {
      const promocoes = _.map(this.promocoesAtivas, promo => ({
        key: `promo-${promo.id}`,
        tipo: 'promocao',
        entidade: promo,
        titulo: promo.nome,
      }));
      const cupons = _.map(this.cuponsAtivos, cupom => ({
        key: `cupom-${cupom.id}`,
        tipo: 'cupom',
        entidade: cupom,
        titulo: String(cupom.codigo || '').toUpperCase(),
      }));
      return promocoes.concat(cupons);
    },
    ofertasVisiveis() {
      return _.take(this.ofertasAtivas, OFERTAS_VISIVEIS);
    },
    // Duas colunas para a lista não deixar um vazio no meio do card: a
    // primeira fica com a metade de cima (e com o item extra no total ímpar).
    ofertasColunas() {
      const visiveis = this.ofertasVisiveis;
      const corte = Math.ceil(visiveis.length / 2);
      return [visiveis.slice(0, corte), visiveis.slice(corte)];
    },
    ofertasOcultas() {
      return Math.max(0, this.ofertasAtivas.length - OFERTAS_VISIVEIS);
    },
    // Larguras da linha "pedidos + notificações (+ CTA cupom)".
    // Sem promoção, o banner de cupom entra nessa linha, então as colunas
    // se ajustam para caber os 12 pontos do grid.
    pedidosColClass() {
      if (this.isCardapioDigital) {
        return this.temPromocao ? '' : 'md7';
      }
      return this.temPromocao ? 'md7' : 'md5';
    },
    notifColClass() {
      return this.temPromocao ? 'md5' : 'md4';
    },
    bannerColClass() {
      return this.isCardapioDigital ? 'md5' : 'md3';
    },
    lojaAberta() {
      const delivery = this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.delivery
        ? this.estabelecimentoSelecionado.delivery[0]
        : null;
      return !!(delivery && delivery.aberto == 1);
    },
    primeiroNome() {
      const user = this.$store.getters.user;
      if (!user || !user.nome) return 'parceiro';
      return user.nome.split(' ')[0];
    },
    saudacao() {
      const hora = this.$dayjs().hour();
      if (hora < 12) return 'Bom dia';
      if (hora < 18) return 'Boa tarde';
      return 'Boa noite';
    },
    dataLonga() {
      return this.$dayjs().format('dddd, D [de] MMMM [de] YYYY');
    },
    meta() {
      return this.resumo || {};
    },
    faturamento7() {
      return parseFloat(this.meta.faturamento7) || 0;
    },
    pedidos7() {
      return parseInt(this.meta.pedidos_confirmados7) || 0;
    },
    ticketMedio7() {
      return this.pedidos7 ? this.faturamento7 / this.pedidos7 : 0;
    },
    faturamento28() {
      return parseFloat(this.meta.faturamento28) || 0;
    },
    pedidos28() {
      return parseInt(this.meta.pedidos_confirmados28) || 0;
    },
    ticketMedio28() {
      return this.pedidos28 ? this.faturamento28 / this.pedidos28 : 0;
    },
    clientesUnicos28() {
      return parseInt(this.meta.clientes_unicos28) || 0;
    },
    clientesNovos28() {
      return parseInt(this.meta.clientes_novos28) || 0;
    },
    taxaCancelamento28() {
      return (parseFloat(this.meta.taxa_cancelamento_28) || 0) * 100;
    },
    metadadosAtualizadosEm() {
      if (!this.meta.data_atualizacao) return '';
      return this.$dayjs(this.meta.data_atualizacao).format('DD/MM [às] HH:mm');
    },
    pedidosPorHora() {
      const horas = this.meta.pedidos_por_hora7;
      if (!horas || !horas.length) return _.fill(Array(24), 0);
      return _.map(horas, h => Number(h) || 0);
    },
    temPedidosPorHora() {
      return _.sum(this.pedidosPorHora) > 0;
    },
    horaPico() {
      if (!this.temPedidosPorHora) return null;
      return _.indexOf(this.pedidosPorHora, _.max(this.pedidosPorHora));
    },
    atalhos() {
      const atalhos = [
        { label: 'Cardápio', icon: 'restaurant_menu', to: '/delivery/cardapio', bg: 'rgba(29,154,90,0.12)', color: '#1d9a5a' },
        { label: 'Criar cupom', icon: 'local_offer', to: '/delivery/cupom-desconto', bg: 'rgba(201,151,30,0.12)', color: '#C9971E', perfis: ['administrador'] },
        { label: 'Horários', icon: 'schedule', to: '/delivery/horario', bg: 'rgba(48,96,202,0.12)', color: '#3060CA' },
        { label: 'Relatório', icon: 'insert_chart', to: '/delivery/relatorio', bg: 'rgba(100,50,180,0.12)', color: '#6432b4' },
        { label: 'Financeiro', icon: 'account_balance_wallet', to: '/delivery/financeiro', bg: 'rgba(0,150,136,0.12)', color: '#00897B', perfis: ['administrador'] },
        { label: 'Taxa de entrega', icon: 'place', to: '/delivery/entrega', bg: 'rgba(255,75,75,0.12)', color: '#FF4B4B' },
        { label: 'Campanha de promoção', icon: 'loyalty', to: '/delivery/marketing/campanhas', bg: 'rgba(233,30,99,0.12)', color: '#D81B60', marketplaceOnly: true, perfis: ['administrador'] },
        { label: 'Configurações', icon: 'settings', to: '/delivery/configuracoes', bg: 'rgba(96,125,139,0.12)', color: '#546E7A' },
      ];
      // Campanha de promoção é exclusiva do marketplace — remove para cardápio digital
      return atalhos.filter(a => !a.marketplaceOnly || !this.isCardapioDigital).filter(a => this.$root.podeAcessarPerfil(a.perfis));
    },
    chartHoras() {
      const horas = this.pedidosPorHora;
      const pico = this.horaPico;
      const labels = _.map(_.range(24), h => `${h}h`);
      const data = _.map(horas, (v, h) => ({
        value: v,
        itemStyle: {
          color: h === pico ? '#e59a1b' : '#1d9a5a',
          barBorderRadius: [4, 4, 0, 0],
          opacity: h === pico ? 1 : 0.75,
        },
      }));

      return [
        ['tooltip.trigger', 'axis'],
        ['tooltip.formatter', (params) => `<b>${params[0].name}</b><br/>${params[0].value} pedidos`],
        ['legend.show', false],
        ['grid.top', '18'],
        ['grid.left', '40'],
        ['grid.right', '10'],
        ['grid.bottom', '30'],
        ['xAxis', {
          type: 'category',
          data: labels,
          axisLine: { lineStyle: { color: '#e5e5e5' } },
          axisTick: { show: false },
          axisLabel: { color: '#999', interval: 2 },
        }],
        ['yAxis', {
          type: 'value',
          minInterval: 1,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#999' },
          splitLine: { lineStyle: { color: '#f2f2f2' } },
        }],
        ['series', [
          {
            name: 'Pedidos',
            type: 'bar',
            data,
            barMaxWidth: 16,
          },
        ]],
      ];
    },
  },
  created() {
    window.getApp.$on('CHANGE_ESTABELECIMENTO', this.fetchData);
    this.timerAgora = setInterval(() => {
      this.agora = Date.now();
    }, 60000);
  },
  beforeDestroy() {
    window.getApp.$off('CHANGE_ESTABELECIMENTO', this.fetchData);
    if (this.timerAgora) clearInterval(this.timerAgora);
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.estabelecimentoSelecionado || !this.estabelecimentoSelecionado.id) {
        this.resumo = null;
        this.cupons = [];
        return;
      }

      this.loading = true;
      this.$root.getPromocoes(this.estabelecimentoSelecionado.id);
      this.fetchCupons();
      try {
        const { data } = await this.$axios.get('/dashboard/resumo', {
          params: { estabelecimento_id: this.estabelecimentoSelecionado.id },
        });
        this.resumo = data;
        this.loadKey++;
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Erro ao carregar o painel. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
      this.loading = false;
    },
    async fetchCupons() {
      const loja = this.estabelecimentoSelecionado;
      if (!loja || !loja.id) {
        this.cupons = [];
        return;
      }

      this.loadingOfertas = true;
      try {
        const { data } = await this.$axios.get('/cupom-desconto', {
          params: { estabelecimento_id: loja.id },
        });
        if (!this.estabelecimentoSelecionado || this.estabelecimentoSelecionado.id !== loja.id) {
          return;
        }
        this.cupons = data || [];
      } catch (error) {
        this.cupons = [];
      }
      this.loadingOfertas = false;
    },
    cupomEntregaGratis(cupom) {
      return Number(cupom.entrega_gratis) === 1 || Number(cupom.taxa_entrega) === 1;
    },
    cupomPercentual(cupom) {
      return Math.round(Number(cupom.valor_desconto) * 100);
    },
    abrirArteOferta(oferta) {
      if (!oferta || !oferta.entidade) {
        return;
      }
      const params = {
        estabelecimento: this.estabelecimentoSelecionado || {},
        recemAtivado: false,
        origem: 'home',
      };
      if (oferta.tipo === 'cupom') {
        this.$refs.dialogArte.abrirCupom({ cupom: oferta.entidade, ...params });
        return;
      }
      this.$refs.dialogArte.abrirPromocao({ promo: oferta.entidade, ...params });
    },
    abrirSelecaoLoja() {
      window.getApp.$emit('SELECT_ESTABELECIMENTO');
    },
    abrirPedido(pedido) {
      // Mesmo mecanismo do selectPedido da tela de Pedidos
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$root.pedido_mobile = _.cloneDeep(pedido);
      }
      this.$root.pedido = _.cloneDeep(pedido);
      this.$router.push('/delivery/pedidos');
    },
    resumoItens(pedido) {
      const itens = pedido.itens || [];
      if (!itens.length) return '';
      const partes = itens.map(ip => {
        const nome = ip.item && ip.item.nome ? ip.item.nome : 'Item';
        return `${ip.quantidade}x ${nome}`;
      });
      return this.truncate(partes.join(', '), 60);
    },
    formaPagamentoLabel(pedido) {
      if (pedido.forma_pagamento_id == -1) return 'Pagamento online';
      if (pedido.formaPagamento && pedido.formaPagamento.nome) return pedido.formaPagamento.nome;
      return 'Pagamento na entrega';
    },
    tempoEspera(pedido) {
      const minutos = this.$dayjs(this.agora).diff(this.$dayjs(pedido.data), 'minute');
      return Math.max(0, minutos);
    },
    tempoClass(pedido) {
      const minutos = this.tempoEspera(pedido);
      if (minutos >= 8) return 'home-pedido__tempo--red';
      if (minutos >= 4) return 'home-pedido__tempo--amber';
      return 'home-pedido__tempo--green';
    },
    formatNota(valor) {
      return Number(valor || 0).toFixed(1).replace('.', ',');
    },
    formatDataCurta(data) {
      if (!data) return '';
      return this.$dayjs(data).format('DD/MM');
    },
    formatDataNotificacao(data) {
      if (!data) return '';
      return this.$dayjs(data).format('DD/MM [às] HH:mm');
    },
    truncate(texto, tamanho) {
      if (!texto) return '';
      return texto.length > tamanho ? `${texto.substring(0, tamanho)}...` : texto;
    },
    // Mesma lógica de CampanhaPreviewCard: público segmentado quando há
    // publico_nomes preenchido, caso contrário público aberto.
    isPromoSegmentada(promo) {
      return !!(promo && promo.publico_nomes && String(promo.publico_nomes).trim());
    },
    // Parte do desconto custeada pela loja = desconto total - subsídio Bigou.
    descontoLojistaPromo(promo) {
      const desconto = Number(promo.desconto) || 0;
      const subsidio = Number(promo.valorSubsidio) || 0;
      const liquido = desconto - subsidio;
      return liquido > 0 ? liquido : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  font-family: 'Poppins', 'Roboto', 'Helvetica', sans-serif;
}

// ===== Empty store =====
.home-empty-store {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
  gap: 8px;
}

.home-empty-store__icon {
  font-size: 56px !important;
  color: #d5d5d5 !important;
}

.home-empty-store__title {
  font-size: 20px;
  font-weight: 600;
  color: #555;
}

.home-empty-store__sub {
  font-size: 14px;
  color: #999;
}

.home-empty-store__cta {
  margin-top: 8px;
  text-transform: none;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  border-radius: 8px;
}

// ===== Hero =====
.home-hero {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background: linear-gradient(120deg, #0e3d22 0%, #17603a 55%, #1d9a5a 100%);
  padding: 28px 32px;
  color: #fff;
  box-shadow: 0 8px 30px rgba(14, 61, 34, 0.25);
}

.home-hero__decor {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);

  &--1 { width: 220px; height: 220px; right: -60px; top: -80px; }
  &--2 { width: 140px; height: 140px; right: 140px; bottom: -70px; background: rgba(255,255,255,0.045); }
}

.home-hero__content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.home-hero__greeting {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
}

.home-hero__date {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
  text-transform: capitalize;
}

.home-hero__chips {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.home-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  border-radius: 999px;
  padding: 5px 12px;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &--open {
    background: rgba(255, 255, 255, 0.14);
    color: #c8f5da;

    .home-chip__dot {
      background: #4ade80;
      box-shadow: 0 0 0 3px rgba(74, 222, 128, 0.25);
    }
  }

  &--closed {
    background: rgba(255, 132, 0, 0.22);
    color: #ffd9ac;

    .home-chip__dot {
      background: #ff9d2e;
      box-shadow: 0 0 0 3px rgba(255, 157, 46, 0.25);
    }
  }

  &--neutral {
    background: rgba(255, 255, 255, 0.12);
    color: #d9efe2;
  }
}

.home-hero__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.home-hero__stat {
  text-align: right;
}

.home-hero__stat-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
}

.home-hero__stat-value {
  font-size: 34px;
  font-weight: 700;
  line-height: 1.15;
}

.home-hero__stat-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
}

.home-hero__stat-skeleton {
  height: 40px;
  width: 180px;
  margin-left: auto;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(255,255,255,0.12) 25%, rgba(255,255,255,0.22) 50%, rgba(255,255,255,0.12) 75%);
  background-size: 200% 100%;
  animation: home-shimmer 1.2s infinite;
}

.home-hero__refresh {
  background: rgba(255, 255, 255, 0.12) !important;
}

// ===== Promoções + Banner CTA cupom (lado a lado) =====
.home-promo-row {
  display: flex;
  align-items: stretch;
  gap: 20px;
  flex-wrap: wrap;
}

.home-promo-col {
  flex: 999 1 480px;
  min-width: 0;
}

.home-banner-col {
  flex: 1 1 300px;
  max-width: 420px;
  display: flex;

  // Componente não renderiza nada quando nenhuma regra se aplica (sobra só
  // um nó de comentário) — esconde a coluna para a seção ocupar tudo
  &:empty {
    display: none;
  }
}

// AnnouncementBanners não renderiza nada quando nenhuma regra se aplica
// (sobra só um nó de comentário) — esconde a coluna nesse caso
.home-banner-flex:empty {
  display: none;
}

// ===== Cards =====
.home-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  height: 100%;
  position: relative;
}

// ===== Seções =====
.home-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.home-section-title-row {
  display: flex;
  align-items: center;
  gap: 12px;

  // dentro do cabeçalho o subtítulo não precisa do espaço inferior,
  // assim o ícone centraliza corretamente com o bloco de texto
  .home-section-sub {
    margin-bottom: 0;
  }
}

.home-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.home-section-sub {
  font-size: 12px;
  color: #aaa;
  margin-bottom: 14px;
}

.home-link-btn {
  text-transform: none;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
}

.home-chart-skeleton {
  height: 240px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f5f5f5 25%, #eeeeee 50%, #f5f5f5 75%);
  background-size: 200% 100%;
  animation: home-shimmer 1.2s infinite;
}

@keyframes home-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.home-peak {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(245, 166, 35, 0.08);
  font-size: 12.5px;
  color: #8a6100;

  b { font-weight: 700; }
}

// ===== Pedidos aguardando =====
.home-alert__pulse {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #1d9a5a;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  animation: home-pulse 1.6s infinite;
}

@keyframes home-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(29, 154, 90, 0.45); }
  70%  { box-shadow: 0 0 0 12px rgba(29, 154, 90, 0); }
  100% { box-shadow: 0 0 0 0 rgba(29, 154, 90, 0); }
}

.home-pedido {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 12px;
  border: 1.5px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #1d9a5a;
    box-shadow: 0 4px 14px rgba(29, 154, 90, 0.15);
    transform: translateY(-1px);
  }

  &:last-of-type { margin-bottom: 0; }
}

.home-pedido__info {
  flex: 1;
  min-width: 0;
}

.home-pedido__cliente {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.home-pedido__nome {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-pedido__tempo {
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 1px 8px;

  &--green { background: rgba(29, 154, 90, 0.1); color: #1d9a5a; }
  &--amber { background: rgba(245, 166, 35, 0.12); color: #c07d0a; }
  &--red   { background: rgba(255, 75, 75, 0.1); color: #e03131; }
}

.home-pedido__itens {
  font-size: 12.5px;
  color: #555;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-pedido__meta {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}

.home-pedido__sep {
  margin: 0 5px;
  color: #ccc;
}

.home-pedido__total {
  font-weight: 700;
  color: #1d9a5a;
}

.home-pedido__btn {
  background: #1d9a5a !important;
  color: #fff !important;
  border-radius: 8px;
  font-weight: 700;
  text-transform: none;
  font-family: 'Poppins', sans-serif;
  flex-shrink: 0;
}

// ===== Notificações =====
.home-notif {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-of-type { border-bottom: none; }
}

.home-notif__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(48, 96, 202, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.home-notif__info {
  flex: 1;
  min-width: 0;
}

.home-notif__titulo {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}

.home-notif__msg {
  font-size: 12px;
  color: #888;
  margin-top: 1px;
  line-height: 1.4;
}

.home-notif__data {
  font-size: 11px;
  color: #bbb;
  margin-top: 2px;
}

.home-notif__link {
  text-transform: none;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  min-width: 0;
}

// ===== Novidades para ativar =====
.home-promo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-of-type { border-bottom: none; }
}

.home-promo__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(245, 166, 35, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-promo__info {
  flex: 1;
  min-width: 0;
}

.home-promo__linha-nome {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.home-promo__nome {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-promo__segmentado {
  background: #eeeafb;
  color: #5b4bc4;
  font-size: 9.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;
}

.home-promo__aberto {
  background: #edf0f3;
  color: #5b6472;
  font-size: 9.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;
}

.home-promo__subsidio {
  font-size: 11px;
  color: #b96a00;
  font-weight: 600;
  margin-top: 3px;
}

.home-promo__detalhe {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
  flex-wrap: wrap;
}

.home-promo__preco-de {
  text-decoration: line-through;
  color: #bbb;
}

.home-promo__preco-por {
  font-weight: 700;
  color: #1d9a5a;
}

.home-promo__vigencia {
  color: #aaa;
}

.home-promo__badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #1d7d4a;
  background: #dcefe4;
  border-radius: 999px;
  padding: 4px 12px;
  flex-shrink: 0;
}

.home-promo__hint {
  padding-top: 12px;
  font-size: 11.5px;
  color: #aaa;
}

// ===== Ofertas ativas para divulgar =====
.home-ofertas-cols {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 32px;
}

@media (max-width: 959px) {
  .home-ofertas-cols {
    grid-template-columns: minmax(0, 1fr);
  }
}

.home-ofertas-col {
  min-width: 0;
}

.home-oferta {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-of-type { border-bottom: none; }
}

.home-oferta__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &--cupom { background: rgba(29, 154, 90, 0.12); }
  &--promocao { background: rgba(245, 166, 35, 0.12); }
}

.home-oferta__info {
  flex: 1;
  min-width: 0;
}

.home-oferta__linha-nome {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.home-oferta__nome {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-oferta__tag {
  font-size: 9.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;

  &--cupom {
    background: #dcefe4;
    color: #1d7d4a;
  }

  &--promocao {
    background: #fbeccd;
    color: #a86b00;
  }
}

.home-oferta__detalhe {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
  flex-wrap: wrap;
}

.home-oferta__preco-de {
  text-decoration: line-through;
  color: #bbb;
}

.home-oferta__preco-por {
  font-weight: 700;
  color: #1d9a5a;
}

.home-oferta__meta {
  color: #aaa;
}

.home-oferta__btn {
  background: #1d9a5a !important;
  color: #fff !important;
  border-radius: 8px;
  font-weight: 700;
  text-transform: none;
  font-family: 'Poppins', sans-serif;
  flex-shrink: 0;
}

.home-oferta__hint {
  padding-top: 12px;
  font-size: 11.5px;
  color: #aaa;
}

// ===== Atalhos =====
.home-shortcuts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.home-shortcut {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #1d9a5a;
    box-shadow: 0 4px 14px rgba(29, 154, 90, 0.12);
    transform: translateY(-1px);
  }
}

.home-shortcut__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-shortcut__label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

// ===== Mini stats 30d =====
.home-mini {
  padding: 6px 0;
}

.home-mini__label {
  font-size: 11px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.home-mini__value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-top: 2px;

  &--red { color: #FF4B4B; }
}

// ===== Empty =====
.home-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #ccc;
  gap: 8px;
  font-size: 14px;
}

.home-empty__icon {
  font-size: 36px !important;
  color: #ddd !important;
}
</style>
